import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';

import { DomainId } from '@domgen/dgx-fe-common';
import {
  DOMAIN_CONFIG,
  domainIdFromDomain,
  ENVIRONMENT,
  RUNTIME_CONFIG,
} from '@domgen/dgx-fe-config';
import { environment } from '@pr/util-environment';
import 'hammerjs';
import { AppModule } from './app/app.module';
import posthog from 'posthog-js';

if (environment.production) {
  enableProdMode();
}

let configXhr = null;
configXhr = new XMLHttpRequest();
configXhr.open('GET', 'config.json');
configXhr.send();
configXhr.onreadystatechange = function () {
  if (this.status === 200 && this.readyState === 4) {
    const config = JSON.parse(configXhr.responseText);

    Promise.all([loadDomainConfig()]).then(([domainConfig]) => {
      if (environment.production) {
        enableProdMode();
      }

      posthog.init(config.POSTHOG_KEY, {
        api_host: config.POSTHOG_HOST,
        person_profiles: 'identified_only',
        defaults: '2025-05-24',
      });

      const { recaptchaSiteKey } = config;

      platformBrowserDynamic([
        {
          provide: DOMAIN_CONFIG,
          useValue: domainConfig,
        },
        {
          provide: RUNTIME_CONFIG,
          useValue: config,
        },
        {
          provide: ENVIRONMENT,
          useValue: environment,
        },
        { provide: RECAPTCHA_V3_SITE_KEY, useValue: recaptchaSiteKey },
      ]).bootstrapModule(AppModule);
    });
  }
};

async function loadDomainConfig(): Promise<any> {
  const domainId: DomainId = domainIdFromDomain(
    DomainId.DomesticAndGeneral,
    {}
  );

  const response = await fetch(`configs/domains/${domainId}.json`);
  return response.json();
}
